import { BaseResource } from './base';
import { RequestOptions } from '../types';
import {
  CatalogResponse,
  CatalogGym,
  CityWithGyms,
  SearchCatalogParams,
  SearchCatalogResponse,
  CreateLeadDto,
  LeadSubmissionResponse,
} from '../models/catalog';

/**
 * Public Catalog Resource
 * Handles public-facing catalog operations (no authentication required)
 */
export class PublicCatalogResource extends BaseResource {
  private basePath = 'catalog';

  /**
   * Search gyms in the public catalog
   */
  async searchCatalog(
    params?: SearchCatalogParams,
    options?: RequestOptions
  ): Promise<SearchCatalogResponse> {
    return this.client.get<SearchCatalogResponse>(`${this.basePath}/search`, params, options);
  }

  /**
   * Get featured gyms
   */
  async getFeaturedGyms(limit?: number, options?: RequestOptions): Promise<CatalogGym[]> {
    const params = limit ? { limit: String(limit) } : undefined;
    return this.client.get<CatalogGym[]>(`${this.basePath}/featured`, params, options);
  }

  /**
   * Get list of cities with available gyms
   */
  async getCitiesWithGyms(options?: RequestOptions): Promise<CityWithGyms[]> {
    return this.client.get<CityWithGyms[]>(`${this.basePath}/cities`, undefined, options);
  }

  /**
   * Get complete catalog details by gym slug
   */
  async getCatalogBySlug(slug: string, options?: RequestOptions): Promise<CatalogResponse> {
    return this.client.get<CatalogResponse>(`${this.basePath}/${slug}`, undefined, options);
  }

  /**
   * Submit a lead form for a specific gym
   */
  async submitLead(
    slug: string,
    data: CreateLeadDto,
    options?: RequestOptions
  ): Promise<LeadSubmissionResponse> {
    return this.client.post<LeadSubmissionResponse>(`${this.basePath}/${slug}/lead`, data, options);
  }
}
